import React, { useState } from "react";
import { MuiBox, MuiTypography } from "components/atoms";
import FolderIcon from "assets/images/svg-icons/foldericon.svg";
import FolderSharedIcon from "assets/images/svg-icons/folderShareIcon.svg";
import FolderMenu from "../FolderMenu";
import dayjs from "dayjs";
import LinkIcon from "assets/images/svg-icons/linkIcon.svg";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import "dayjs/locale/hi";
import "dayjs/locale/gu";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import StarFillIcon from "assets/images/svg-icons/starFill.svg";
import { useLocation } from "react-router-dom";
import { Skeleton } from "@mui/material";

const FolderCard = ({
  page,
  onSelect,
  selected,
  onDoubleClick,
  item,
  clearSelection,
  selectedItems,
}) => {
  const [contextMenu, setContextMenu] = useState(null);
  const { i18n } = useTranslation();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const disableAnimation = user?.default_animation === true || "true";
  const isStarPage = location.pathname.includes("/drive/starred");
  const isSharePage = location.pathname.includes("/drive/sharelink");
  const [iconLoaded, setIconLoaded] = useState(false);

  const handleContextMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
    });
  };

  const folderIconSrc =
    item?.is_shared || item?.shared_by
      ? FolderSharedIcon
      : FolderIcon;

  return (
    <MuiBox
      sx={{
        backgroundColor: selected ? "background.blue400" : "background.blue200",
        p: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: "8px",
        height: "60px",
        cursor: "pointer",
        transition: disableAnimation
          ? "none"
          : "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
        ...(disableAnimation
          ? {
              "&:hover": {
                backgroundColor: "background.blue300",
              },
            }
          : {
              "&:hover": {
                transform: "translateY(-2px)",
                backgroundColor: "background.blue300",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.10)",
              },
            }),
      }}
      onClick={onSelect}
      onContextMenu={handleContextMenu}
    >
      <MuiBox
        sx={{
          display: "flex",
          alignItems: "start",
          gap: "12px",
          flex: 1,
          minWidth: 0,
        }}
        // onClick={onSelect}
        onDoubleClick={onDoubleClick}
      >
        <MuiBox sx={{ height: "32px", width: "32px", flexShrink: 0 }}>
          {!iconLoaded && (
            <Skeleton
              variant="rounded"
              width={32}
              height={32}
              sx={{ borderRadius: "4px" }}
            />
          )}
          <img
            src={folderIconSrc}
            alt="folderIcon"
            className="img-contain"
            onLoad={() => setIconLoaded(true)}
            style={{
              display: iconLoaded ? "block" : "none",
              width: "100%",
              height: "100%",
            }}
          />
        </MuiBox>
        <MuiBox sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
          <MuiTypography
            fontWeight="500"
            variant="14"
            color="text.darkBlack"
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {item?.name}
          </MuiTypography>
          <MuiBox sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {item?.is_starred && !isStarPage && (
              <img
                src={StarFillIcon}
                alt="folderIcon"
                className="img-contain"
                style={{ width: "14px", height: "14px", marginRight: "4px" }}
              />
            )}
            <MuiTypography fontWeight="400" variant="12" color="text.gray1400">
              {dayjs(Number(item?.updated_at))
                .locale(i18n.language)
                .format("MMMM D, YYYY")}
            </MuiTypography>
          </MuiBox>
        </MuiBox>
      </MuiBox>
      <MuiBox
        sx={{
          width: "fit-content",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {item?.general_access?.visibility === "public" && (
          <img src={LinkIcon} alt="linkIcon" className="img-contain" />
        )}
        {!isSharePage && (
          <FolderMenu
            page={page}
            item={item}
            clearSelection={clearSelection}
            selectedItems={selectedItems}
            contextMenu={contextMenu}
            setContextMenu={setContextMenu}
          />
        )}
      </MuiBox>
      {/* <FolderMenu page={page} item={item} /> */}
    </MuiBox>
  );
};

export default FolderCard;
